<ac-form *ngIf="dialogConfig.ready"
         [formSchema]="schema"
         [formModel]="tenant"
         formModelName="tenant"
         [formSettings]="formSettings">

    <div id="tenant-commitment-content">
        <ac-checkbox labelText="Enable Partner Commercial Track"
                     [(acModel)]="tenant.isCommitmentEnabled"
                     checkboxId="tenant-is-commitment-enabled">
        </ac-checkbox>

        <div class="terms-and-condition-label">Terms & Conditions</div>

        <file-selection (fileIdChanged)="tenant.commitmentFileId = $event"
                        [getAdditionalSystemFiles]="false"
                        filePropertyName="commitmentFileId"
                        label="Terms and Conditions"
                        fileType="COMMITMENT_TYPE"
                        [fileTypes]="['txt', 'md']"
                        [ngDisabled]="!tenant.isCommitmentEnabled"
                        [showImage]="false"
                        [showText]="true"
                        [fileObject]="commitmentObject"
                        [tenantId]="tenant.tenantId">
        </file-selection>
    </div>

</ac-form>
